import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
`;

export const Label = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #232323;
    font-family: 'Inter', sans-serif;
`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #ffffff;
    border-radius: 12px;
    border: 1px solid #e0e0e0;
    overflow: hidden;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    gap: 16px;

    & + & {
        border-top: 1px solid #f0f0f0;
    }
`;

export const RowLabel = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #232323;
    font-family: 'Inter', sans-serif;
`;

export const RowValue = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #6b6b6b;
    font-family: 'Inter', sans-serif;
    text-align: right;
`;
